import React from 'react'
import { Box, Typography } from '@mui/material'
import { mappingType } from 'Pages/Admin/AdminMapping/@signals'
import { MAPPING_TYPE } from 'Pages/Admin/AdminMapping/@constants'


export default function AdminMappingDrawerTitle() {
	const title = mappingType.value === MAPPING_TYPE.ACRISS
		? " Custom Acriss Mapping "
		: " Custom Categories Mapping"

	return <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-start" }}>
		<Typography variant="h6">{title}</Typography>
	</Box>
}